import React, { useContext, useEffect } from 'react';

import { useModal } from 'hooks';
import { WindowSizeContext } from 'contexts/WindowSizeContext';
import Icon from 'components/Icon';

import css from '../ModalContainer.module.scss';

// Singleton that renders all modals and is meant to be added to the root of the app.
const PortalModalContainer: React.FC = () => {
    const { modals, closeModal } = useModal();
    const { isMobile } = useContext(WindowSizeContext);

    // Topmost modal on the stack (if it exists)
    const currentModal = modals[modals.length - 1] ?? null;

    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.code === 'Escape' || e.key === 'Escape') {
                e.stopPropagation();
                closeModal();
            }
        };
        window.addEventListener('keydown', handleEsc);

        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [closeModal, currentModal]);

    if (!currentModal) {
        return null;
    }

    // Render current modal
    return (
        <div className={css.modalContainer} key={String(Math.random())}>
            <div className={css.modalContainerContent}>
                {!isMobile && (
                    <div className={css.modalContainerClose} onClick={closeModal}>
                        <Icon name="cross-thick" width={16} color="white" />
                    </div>
                )}
                {currentModal.content}
            </div>
        </div>
    );
};

export default PortalModalContainer;
